<template>
  <div>
    <appHeader></appHeader>
    <appModal></appModal>
    <div class="container-fluid transaction-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4 marginForHeader">
            <h4>Setup Status</h4>
            <p :key="status">{{ status }}</p>
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import Modal from "@/components/Modal.vue";
import { mapState } from "vuex";

export default {
  name: "FundingSetupResult",
  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appModal: Modal,
  },
  data() {
    return {
      status: "",
    };
  },
  computed: {
    clientSecret() {
      return new URLSearchParams(window.location.search).get(
        "setup_intent_client_secret"
      );
    },
  },
  methods: {
    retreiveSetupIntent: async function () {
      const { setupIntent } = await this.$stripe.retrieveSetupIntent(
        this.clientSecret
      );

      // Inspect the SetupIntent `status` to indicate the status of the payment
      // to your customer.
      //
      // Some payment methods will [immediately succeed or fail][0] upon
      // confirmation, while others will first enter a `processing` state.
      //
      // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
      switch (setupIntent.status) {
        case "succeeded": {
          this.status = "Success! Your payment method has been saved.";
          break;
        }

        case "processing": {
          this.status =
            "Processing payment details. We'll update you when processing is complete.";
          break;
        }

        case "requires_payment_method": {
          this.status =
            "Failed to process payment details. Please try another payment method.";

          // Redirect your user back to your payment page to attempt collecting
          // payment again

          break;
        }
      }
    },
  },

  async created() {
    try {
      await this.retreiveSetupIntent();
    } catch (e) {
      console.error(e);
      this.status = e;
    }
  },
};
</script>

<style lang="scss" scoped>
.marginForHeader {
  margin-top: 50px;
}
</style>